import Mixpanel from "mixpanel-browser";
import { createContext, useEffect, useState } from "react";

export const MixpanelContext = createContext({
  mixpanel: null,
});

export function MixpanelProvider({ children, mixpanelToken }) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Mixpanel.init(mixpanelToken, {
      debug: false,
      track_pageview: false,
      persistence: "localStorage",
    });

    setIsLoading(false);
  }, [mixpanelToken]);

  return (
    <MixpanelContext.Provider value={{ mixpanel: Mixpanel }}>
      {!isLoading && children}
    </MixpanelContext.Provider>
  );
}
